/** Приводит произвольное значение из catch к Error для логгера. */
export function toError(error: unknown): Error {
  return error instanceof Error ? error : new Error(String(error));
}
